"use strict";
window.jQuery = window.$ = require('jquery');
require('owl.carousel');
require('bootstrap');
// Función para inicializar el carrusel de productos cruzados
function initCrossSellCarousel() {
    $('#product-cross-sell').owlCarousel({
      margin: 5,
      autoplayTimeout: 3000,
      autoplayHoverPause: false,
      autoWidth: false,
      nav: true,
      loop: true,
      dots: true,
      items: 4,
      responsive: {
        0: {
          items: 1,
          nav: false,
          dots: false
        },
        600: {
          items: 1,
          nav: false,
          dots: false
        },
        1000: {
          items: 4,
          nav: false,
          dots: false,
          loop: false
        },
        1600: {
          items: 4,
          nav: false,
          loop: false
        }
      }
    });
  }

  // Función para inicializar tooltips en el body
  function initTooltips() {
    $("body").tooltip({ selector: '[data-toggle=tooltip]', placement: 'bottom' });
  }

  // Función para mostrar/ocultar el slider de imágenes
  function initImageSlider() {
    $(".single-detail-images").click(function () {
      $('#carouselExampleIndicators').show();
    });

    $("#close_product_slider").click(function () {
      $('#carouselExampleIndicators').hide();
    });
  }

  // Función para inicializar el carrusel para dispositivos móviles
  function initMobileSlider() {
    $('#mobile-slider-products').owlCarousel({
      margin: 5,
      autoplayTimeout: 3000,
      autoplayHoverPause: false,
      autoWidth: false,
      nav: false,
      loop: false,
      dots: false,
      responsive: {
        0: {
          items: 2,
          nav: true
        },
        600: {
          items: 2,
          nav: false
        },
        1000: {
          items: 4,
          nav: false,
          dots: false,
          loop: false
        }
      }
    });
  }

  // Función para la lógica de agregar a favoritos y hacer un AJAX request
  function initWishlistFeature() {
    const link = $('.addToWishlist').data('wishlist-added');
    const settings = {
      url: link,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: JSON.stringify({
        pid: $('[data-pid]').attr('data-pid')
      }),
    };

    $.ajax(settings).done(function (response) {
      if (response.isAdded > 0) {
        $('.fa-heart').addClass('added-fav');
      }
    });
  }

  // Función para manejar la expansión/contracción de texto
  function initExpandableText() {
    const text = $('.pureyad');
    if(text.length){
        const btn = $('.purgex');
        const h = text[0].scrollHeight;

        if (h > 120) {
          btn.addClass('less').css('display', 'block');
        }

        btn.click(function (e) {
          e.stopPropagation();
          const height = $(window).height() - 150;

          if (btn.hasClass('less')) {
            btn.removeClass('less').addClass('more').text('Ver Menos', 'images/mobile-arrow-icon.svg');
            text.animate({ 'max-height': height + 'px' }, 1000);
            $('#blur-background').addClass('blur-background');
          } else {
            btn.addClass('less').removeClass('more').text('Ver Detalles');
            text.animate({ 'max-height': '100px' }, 1000);
            $('#blur-background').removeClass('blur-background');
          }
        });
    }
  }

  // Funciones para abrir y cerrar el selector móvil
  function openMobileSelect() {
    $('#mobile_select_size_main').show();
    $('.pureyad, .purgex').hide();
  }

  function closeMobileSelect() {
    $('#mobile_select_size_main').hide();
    $('.pureyad, .purgex').show();
  }

  // Función para inicializar el carrusel de pantalla completa
  function initFullScreenCarousel() {
    var $item = $('.carousel-item');
    var $wHeight = $(window).height();
    $item.eq(0).addClass('active');
    $item.height($wHeight);
    $item.addClass('full-screen');

    $('.carousel img').each(function() {
      var $src = $(this).attr('src');
      var $color = $(this).attr('data-color');
      $(this).parent().css({
        'background-image' : 'url(' + $src + ')',
        'background-color' : $color
      });
      $(this).remove();
    });

    $(window).on('resize', function (){
      $wHeight = $(window).height();
      $item.height($wHeight);
    });

    $('.carousel').carousel({
      interval: 6000,
      pause: "false",
    });
  }

  // Función para inicializar tooltips globales
  function initGlobalTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
  }

module.exports =function () {
    // initCrossSellCarousel();
    // initTooltips();
    // initImageSlider();
    // initMobileSlider();
    initWishlistFeature();
    // initExpandableText();
    // initFullScreenCarousel();
    // initGlobalTooltips();
};
